import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import "@/assets/style/index.less";
import $axios from "@/utils/request";
import mixin from "./mixin/index";
import store from "./store/index";
import VueResource from 'vue-resource'

import "@/components/Vant";
// rem
import "amfe-flexible";
import Mui from 'vue-awesome-mui'  
// import 'vue-awesome-mui/mui/dist/css/mui.css'  
// mount with global  
Vue.use(VueResource) 
Vue.use(Mui)
// 把变量挂载到vue的原型上
Vue.prototype.$axios = $axios;

Vue.mixin(mixin);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
